export const OPERATOR_PERMISSIONS_KEYS = {
  all: ['userManagement', 'operatorPermissions'] as const,
  current: () => [...OPERATOR_PERMISSIONS_KEYS.all, 'current'] as const
};
